// <reference types="node" />
// import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import "hammerjs";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment.prod";
if (environment.production) {
}

platformBrowserDynamic().bootstrapModule(AppModule).catch();
